import script from "./Categorias.vue?vue&type=script&setup=true&lang=js"
export * from "./Categorias.vue?vue&type=script&setup=true&lang=js"

import "./Categorias.vue?vue&type=style&index=0&id=27d9247e&lang=css"

const __exports__ = script;

export default __exports__